import React from 'react';
export const ApiContext = React.createContext({API_URL: '/api/'});